import ProjectedIncome from './ProjectedIncome'

export default ProjectedIncome
